export default __webpack_public_path__ + "static/media/Checkoutpage.200c2aec.png";